import { render, staticRenderFns } from "./image.vue?vue&type=template&id=e850f472&scoped=true&"
import script from "./image.vue?vue&type=script&lang=ts&"
export * from "./image.vue?vue&type=script&lang=ts&"
import style0 from "./image.vue?vue&type=style&index=0&id=e850f472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e850f472",
  null
  
)

export default component.exports